import React, { createContext, useContext, useState, ReactNode } from "react";

type UnsavedChangesContextType = {
  hasUnsavedChanges   : boolean;
  setHasUnsavedChanges: (value: boolean) => void;
  showUnsavedModal    : boolean;
  setShowUnsavedModal : (value: boolean) => void;
  pendingNavigation   : string | null;
  setPendingNavigation: (value: string | null) => void;
}

const UnsavedChangesContext = createContext<UnsavedChangesContextType | undefined>(undefined);

export const useUnsavedChanges = () => {
  const context = useContext(UnsavedChangesContext);
  if (!context) {
    throw new Error("useUnsavedChanges must be used within an UnsavedChangesProvider");
  }

  return context;
};

type UnsavedChangesProviderProps = {
  children: ReactNode;
}

export const UnsavedChangesProvider: React.FC<UnsavedChangesProviderProps> = ({ children }) => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState<string | null>(null);

  return (
    <UnsavedChangesContext.Provider
      value={{
        hasUnsavedChanges,
        setHasUnsavedChanges,
        showUnsavedModal,
        setShowUnsavedModal,
        pendingNavigation,
        setPendingNavigation,
      }}
    >
      {children}
    </UnsavedChangesContext.Provider>
  );
};
